const productCardFactory = require('../shelfproduct/shelfbundle-card-factory');

module.exports = function (productGroupService, $timeout, $q) {
    return {
        restrict: 'E',
        scope: {
            productGroupId: '=groupId'
        },
        require: '^wowCardList',
        link(scope, element, attrs, cardListCtrl) {
            function createCards(bundles) {
                return {
                    items: productCardFactory.createBundleCards(bundles.items),
                    totalRecordCount: bundles.totalRecordCount
                };
            }

            function getProducts(group) {
                return group
                    ? productGroupService.getProducts({ pageNumber: 1, pageSize: 20 }, group)
                    : $q.when([]);
            }

            function getCards() {
                // This could potentially break because the product group service needs
                // the product group to be selected inside of itself. If selecting multiple
                // product groups interleaves with getting products, you're gonna have a bad time.
                return getProducts(scope.productGroupId)
                    .then(createCards);
            }

            function init() {
                cardListCtrl.setOptions({
                    getCards,
                    disablePaging: true,
                    enableHeader: false,
                    enableDetail: false,
                    resetScroll: false,
                    shouldGetInspirationCards: false,
                    getSortOptions: null,
                    smallerProductStampsEnabled: true
                });

                $timeout(cardListCtrl.update.bind(cardListCtrl));
            }

            scope.$on('address-update', init);

            init();
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-product-group-products-directive.js
 **/